// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
import login from '@/views/login';
import index from '@/views/index';
import Order from '@/views/pay/Order';
import Module from '@/views/system/Module';
import kuaidiToken from '@/views/system/kuaidiToken';
import Role from '@/views/system/Role';
import Dept from '@/views/system/Dept';
import MachineConfig from '@/views/machine/MachineConfig';

//公司
import cstatistics from '@/views/company/statistics';
import cinfoSet from '@/views/company/infoSet';
import cuser from '@/views/company/user';
import pendingLaunch from '@/views/company/pendingLaunch';
import crecruiting from '@/views/company/recruiting';

//竞赛
import pendingApproval from '@/views/contest/working';
import teacherCerApplication from '@/views/contest/teacherCerApplication';


import capproval from '@/views/company/pendingApproval';
import cworked from '@/views/company/worked';
import cstudentsInfo from '@/views/company/studentsInfo';
import cworkInfo from '@/views/company/workInfo';
//学校
import sstatistics from '@/views/school/statistics';
import suser from '@/views/school/user';
import sworking from '@/views/school/working';
import srecruiting from '@/views/school/recruiting';
import sinfoSet from '@/views/school/infoSet';
import sEventManagement from '@/views/school/eventManagement';
import senterpriseInquiry from '@/views/school/enterpriseInquiry';
//用户
import zhuowanguser from '@/views/user/zhuowanguser';
import verificationCer from '@/views/user/verificationCertificate';
Vue.use(Router);

// 导出路由
const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/public/hnsmartedu_registration',
			name: '卓望门户',
			component: zhuowanguser,
			hidden: true,
			meta: {
				requireAuth: false
			}
		}, 
		{
			path: '/public/verificationCertificate',
			name: '验证证书',
			component: verificationCer,
			hidden: true,
			meta: {
				requireAuth: false
			}
		}, 
		{
			path: '/',
			name: '首页',
			component: login,
			hidden: true,
			meta: {
				requireAuth: false
			}
		}, {
			path: '/login',
			name: '登录',
			component: login,
			hidden: true,
			meta: {
				requireAuth: false
			}
		}, {
			//公司
			path: '/',
			name: '首页',
			component: index,
			iconCls: 'el-icon-tickets',
			children: [{
				path: 'company/statistics',
				name: '数据大厅',
				component: cstatistics,
				meta: {
					requireAuth: true
				},
				
			}, {
				path: 'company/infoSet',
				name: '公司信息',
				component: cinfoSet,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/user',
				name: '用户管理',
				component: cuser,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/Role',
				name: '结算管理',
				component: pendingApproval,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/pendingLaunch',
				name: '待上线项目',
				component: pendingLaunch,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/recruiting',
				name: '招募中项目',
				component: crecruiting,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/working',
				name: '执行中项目',
				component: pendingApproval,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/worked',
				name: '已完成项目',
				component: cworked,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'company/pendingApproval',
				name: '待审批项目',
				component: capproval,
				meta: {
					requireAuth: true
				},
			}, {
				path: 'company/studentsInfo',
				name: '学生信息',
				component: cstudentsInfo,
				meta: {
					requireAuth: true
				},
			}, {
				path: 'company/workInfo',
				name: '任务核验',
				component: cworkInfo,
				meta: {
					requireAuth: true
				},
			}, {
				path: 'school/statistics',
				name: '数据大厅',
				component: sstatistics,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/infoSet',
				name: '首页通知',
				component: sinfoSet,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/EventManagement',
				name: '首页通知',
				component: sEventManagement,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/user',
				name: '用户管理',
				component: suser,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/Role',
				name: '结算管理',
				component: pendingApproval,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/working',
				name: '执行中项目',
				component: pendingApproval,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/worked',
				name: '已完成项目',
				component: cuser,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/students',
				name: '查看学生',
				component: Module,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/class',
				name: '班级管理',
				component: Role,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/certificate',
				name: '证书统计',
				component: Dept,
				meta: {
					requireAuth: true
				}
			}, {
				path: 'school/enterpriseInquiry',
				name: '企业查询',
				component: senterpriseInquiry,
				meta: {
					requireAuth: true
				}
			},
			//新增
			{
				path: 'contest/pendingApproval',
				name: '邀请码发放',
				component: pendingApproval,
				meta: {
					requireAuth: true
				}
			},
			{
				path: 'contest/teacherCerApplication',
				name: '教师认证',
				component: teacherCerApplication,
				meta: {
					requireAuth: true
				}
			},
			]
		},
		{
			path: '*',
			redirect: '/login'
		}
	]
})

const whiteList = ['/login', '/public/hnsmartedu_registration', '/public/verificationCertificate'];

router.beforeEach((to, from, next) => {
	if (whiteList.includes(to.path)) {
		return next();
	}
	const token = localStorage.getItem('logintoken') || localStorage.getItem('token');
	if (to.meta.requireAuth !== false) { // 默认为 true，除非显式设为 false
		if (token) {
			next();
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			});
		}
	}
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js